import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[autoFocus]'
})
export class AutoFocusDirective implements AfterViewInit {

    constructor(
        private _element: ElementRef
    ) {
    }

    ngAfterViewInit(): void {
        $(this._element.nativeElement).focus();
    }
}



// WEBPACK FOOTER //
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/shared/utils/auto-focus.directive.ts